import Page from "./index";
import ContractCopyCof from "./ContractCopyCof.vue";
import CopyCoinCof from "./CopyCoinCof.vue";
import CopyerCof from "./CopyerCof.vue";
import PayerCof from "./PayerCof.vue";
import PayLog from "./PayLog.vue";
import CopyLog from "./CopyLog.vue";
import CopyGlobalCof from "./CopyGlobalCof.vue";
import TraderTag from "./TraderTag.vue";
import TraderCof from "./TraderCof.vue";
import TraderLevel from "./TraderLevel.vue";
import CopyOrder from "./CopyOrder.vue";
import Statistics from "./Statistics.vue";
import TraderStatistics from "./TraderStatistics.vue";
import TraderAvatarList from "./TraderAvatarList.vue";

export default {
  path: "/home/copyOrderConf",
  component: Page,
  redirect: "/home/copyGlobalCof",
  children: [
    // { path: '/home/contractCopyCof', component: ContractCopyCof },
    // { path: '/home/payerCof', component: PayerCof },
    // { path: '/home/payLog', component: PayLog },
    // { path: '/home/copyLog', component: CopyLog },
    { path: "/home/copyGlobalCof", component: CopyGlobalCof },
    { path: "/home/copyerCof", component: CopyerCof },
    { path: "/home/traderTag", component: TraderTag },
    { path: "/home/copyCoinCof", component: CopyCoinCof },
    { path: "/home/traderCof", component: TraderCof },
    { path: "/home/traderLevel", component: TraderLevel },
    { path: "/home/copyOrder", component: CopyOrder },
    { path: "/home/copyStatistics", component: Statistics },
    { path: "/home/traderStatistics", component: TraderStatistics },
    { path: "/home/traderAvatarList", component: TraderAvatarList },
  ],
};

